import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FaUserClock } from "react-icons/fa";
import { GiDuration } from "react-icons/gi";
import { PiStudentBold } from "react-icons/pi";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";
import { motion } from "framer-motion";
import CoursesNavbar from "../components/CoursesNavbar";
import CertificateSection2 from "../components/CertificateSection2";
import GetAdmissionForm from "../components/GetAdmissionForm";
import TrainingFooter from "../components/Tranining Footer";
import TaxationFAQSection from "../components/TaxationFAQSection";
import EnrollNowButton from "../components/EnrollNowButton";
import TaxationCourseInstructors from "../components/TaxationCourseInstructors";
import Meta from "../components/Meta";

export default function TaxationTrainingCourse() {
  const [activeKey, setActiveKey] = useState("overview");
  const [modalSession, setModalSession] = useState(null);

  const courseFacts = [
    { icon: <PiStudentBold />, text: "Total Classes", value: "10+" },
    { icon: <FaUserClock />, text: "Time", value: "8:00 PM – 10:00 PM" },
    { icon: <GiDuration />, text: "Duration", value: "2 Hours+" },
    { icon: <RiCalendarScheduleFill />, text: "Days", value: "Friday & Saturday" },
    { icon: <VscFeedback />, text: "Fee", value: "৳6000" },
  ];

  const courseSessions = [
  {
    title: "Class 1: Introduction to Income Tax",
    topics: [
      "Basic Concepts of Income Tax and Tax Laws",
      "Understanding Tax Returns",
      "Overview of Different Types of Returns",
      "Introduction to Various Types of Taxes"
    ]
  },
  {
    title: "Class 2: Assessment and Advance Tax (Practical)",
    topics: [
      "What is Assessment? Methods of Return Assessment",
      "Sources of Income and Tax-Exempt Incomes",
      "Tax Rates for Individuals and Different Classes of Taxpayers",
      "What is Advance Tax? Who Needs to Pay It?",
      "Procedures for Paying Advance Tax"
    ]
  },
  {
    title: "Class 3: Investment and Rebate",
    topics: [
      "Definition of Investment",
      "Eligible Investment Sectors",
      "What is Rebate? How to Claim Tax Rebates"
    ]
  },
  {
    title: "Class 4: Salary Income Tax Calculation",
    topics: [
      "How to Calculate Tax on Salary Income",
      "Tax Computation for Government and Private Sector Employees"
    ]
  },
  {
    title: "Class 5: Tax on Other Income Sources",
    topics: [
      "Tax Calculation on Income from House Property",
      "Tax on Agricultural Income",
      "Tax on Other Income Sources",
      "What is Capital Gain? How to Calculate It and Related Tax Computation",
      "Understanding Penalties and Interest on Tax Dues"
    ]
  },
  {
    title: "Class 6: Problem Solving Session",
    topics: [
      "Practical Discussion on Common Tax Issues and Case Studies"
    ]
  },
  {
    title: "Class 7: Accounting for Taxation",
    topics: [
      "Understanding Accounts Heads",
      "Preparation of Trial Balance",
      "Preparation of Income Statement and Balance Sheet"
    ]
  },
  {
    title: "Class 8: Business Income and Depreciation",
    topics: [
      "Methods of Calculating Depreciation",
      "Relation Between Source Tax, Advance Tax, and Advance Income Tax",
      "Tax Computation on Business or Professional Income",
      "Preparation of Statement of Assets and Liabilities"
    ]
  },
  {
    title: "Class 9: Additional Tax Concepts & Return Preparation",
    topics: [
      "What is Donation Tax?",
      "What is Surcharge and How It Is Applied?",
      "Completing and Filing the Tax Return Form",
      "Solving Practical Accounting Calculations Related to Tax"
    ]
  },
  {
    title: "Class 10: Online Return Submission",
    topics: [
      "Step-by-Step Guide to Online Tax Return Submission",
      "Practical Problem Solving and Final Review"
    ]
  },
  {
    title: "Certification",
    topics: [
      "Upon successful completion of all modules, participants will receive a Professional Taxation Training Certificate from JK Associates, validating their expertise in income tax computation, return preparation, and compliance."
    ]
  }
];

<Meta title="Schedule X Return Filing in Bangladesh | RJSC Return Filing"
          description="Schedule X Return Filing in Bangladesh. A limited company required schedule X filled each financial year to the authority (RJSC)"
          keywords="Schedule X Return, Schedule X,  Schedule X in Bangladesh, RJSC Return Filing, company office return file, RJSC Return Filing in Bangladesh"
      />

  const openModal = (session) => setModalSession(session);
  const closeModal = () => setModalSession(null);

  const sessionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <CoursesNavbar />
      <div style={{
        background: "linear-gradient(to right, #0066cc, #3399ff)",
        padding: "100px 20px",
        color: "#fff",
        textAlign: "center",
      }}>
        <h1 style={{ fontSize: "38px", fontWeight: "bold" }}>JK Associates
presents
Professional Taxation Training (TAX)</h1>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          A comprehensive course designed for aspiring accounting professionals.
        </p>
      </div>

      <div style={{
        backgroundColor: "#fff",
        maxWidth: "1000px",
        margin: "-80px auto 40px",
        borderRadius: "20px",
        padding: "40px 30px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
      }}>
        <h2 style={{ fontSize: "24px", marginBottom: "20px" }}>Course Overview</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.7" }}>
          This certificate course is jointly organized by JK Associates and Chartered Skills. The training will be held on the premises of JK Associates.
        </p>

        <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k || "overview")} style={{ marginTop: "30px" }}>
          <Tab eventKey="overview" title="Overview">
            <p style={{ marginTop: "20px", fontSize: "15px", lineHeight: "1.7" }}>
              Postgraduate Diploma in Project Management (PGDPM) has been specifically designed as an advanced course for working professionals who want to take on challenges as highly effective project leaders. The Project Management course also focuses on project management methodology that will allow you to initiate and manage a project efficiently and effectively. Participants will learn key project management skills and strategies.
            </p>
          </Tab>

          <Tab eventKey="outline" title="Outline">
            <motion.div
              style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "20px" }}
              initial="hidden"
              animate="visible"
              variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
            >
              {courseSessions.map((session, idx) => (
                <motion.div
                  key={idx}
                  style={{
                    flex: "1 1 45%",
                    backgroundColor: "#3399ff",
                    color: "#fff",
                    borderRadius: "15px",
                    padding: "20px",
                    cursor: "pointer",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                    textAlign: "center"
                  }}
                  variants={sessionVariants}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => openModal(session)}
                >
                  <h5 style={{ fontWeight: "600" }}>{session.title}</h5>
                  <p>Click to view details</p>
                </motion.div>
              ))}
            </motion.div>
          </Tab>
        </Tabs>
      </div>

      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "25px",
        padding: "30px 20px",
      }}>
        {courseFacts.map((item, i) => (
          <motion.div
            key={i}
            style={{
              backgroundColor: "#3399ff",
              color: "#fff",
              borderRadius: "15px",
              width: "200px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
            whileHover={{ scale: 1.05 }}
          >
            <div style={{ fontSize: "28px", marginBottom: "10px" }}>{item.icon}</div>
            <h4 style={{ fontSize: "16px" }}>{item.text}</h4>
            <p style={{ fontSize: "14px" }}>{item.value}</p>
          </motion.div>
        ))}
      </div>

      {modalSession && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex", justifyContent: "center", alignItems: "center",
          zIndex: 9999
        }} onClick={closeModal}>
          <motion.div
            style={{
              backgroundColor: "#3399ff",
              color: "#fff",
              borderRadius: "15px",
              padding: "30px",
              maxWidth: "600px",
              width: "90%",
              maxHeight: "80%",
              overflowY: "auto"
            }}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginBottom: "15px" }}>{modalSession.title}</h3>
            <ul style={{ paddingLeft: "20px" }}>
              {modalSession.topics.map((topic, idx) => (
                <li key={idx} style={{ marginBottom: "10px" }}>{topic}</li>
              ))}
            </ul>
            <button
              onClick={closeModal}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                border: "none",
                color: "#fff",
                borderRadius: "10px",
                cursor: "pointer"
              }}
            >
              Close
            </button>
          </motion.div>
        </div>
      )}
      <EnrollNowButton />
      <CertificateSection2 />
      <TaxationCourseInstructors/>
      <TaxationFAQSection/>
      <GetAdmissionForm />
      <TrainingFooter />
    </>
  );
}
